<template>
	<v-card class="pa-2">
		<div v-if="isSummery">
			<div v-if="!items.length" class="red--text">
				تاکنون اعتبارسنجی ثبت نشده است
			</div>
			<div v-else>
				<div style="border: 1px solid #ededed;background: #f7f7f7;" class="d-flex justify-space-between pa-2" v-for="item in items" :key="item.id">
					<div class="d-flex flex-column justify-center align-center">
						<v-avatar color="secondary" x-large>
							<div>
								<div style="text-align: center;font-size: 10px;color: #fff;">رتبه</div>
								<div class="white--text">{{ item.result || '-' }}</div>
							</div>
						</v-avatar>
					</div>
					<div class="d-flex flex-column justify-center" style="flex-grow: 2;padding: 5px;">
						<div class="d-flex"><v-icon small color="grey" class="ml-2">mdi-calendar</v-icon><span class="grey--text">{{ item.date_Persian.date }}</span></div>
						<div class="d-flex"><span>وضعیت: {{ item.status}}</span></div>
					</div>
				</div>
			</div>
			<div class="mt-2">
				<v-btn @click="showIceManager">
					مدیریت اعتبارسنجی ها
				</v-btn>
			</div>
		</div>
		<div v-else>
			<div v-if="!items.length && isAdmin" class="red--text">
				تاکنون اعتبارسنجی ثبت نشده است
			</div>
			<div v-else>
				<div class="d-flex align-center py-1 mb-5 justify-center" style="border-bottom: 1px dashed grey;" v-if="!isAdmin">
					<span>اعتبار کیف پول شما:</span>
					<span class="grey--text mx-1">{{String(userCredit).toPriceFormat()}} تومان</span>
					<v-btn class="mx-1" color="info" small @click="addWalletCreditCharge">
						<v-icon>mdi-currency-usd</v-icon>
						افزایش اعتبار
					</v-btn>
				</div>
				<div v-for="item in items" :key="item.id" class="d-flex my-2" style="border: 1px solid #ededed;background: #f7f7f7;">
					<div class="d-flex flex-column justify-center align-center">
						<v-avatar color="secondary" x-large>
							<div>
								<div style="text-align: center;font-size: 10px;color: #fff;">رتبه</div>
								<div class="white--text">{{ item.result || '-' }}</div>
							</div>
						</v-avatar>
						<v-btn color="secondary" x-small text @click="editGradeMode=true" v-if="isAdmin && !editGradeMode">ویرایش رتبه</v-btn>
						<div class="d-flex flex-column justify-center align-center" style="width: 100px;" v-if="isAdmin && editGradeMode">
							<v-select hide-details compact v-model="item.result" :items="grades" item-text="title" item-value="value" label="انتخاب کنید"></v-select>
							<v-btn :loading="saveGradeLoading==item.id" class="my-1" color="success" prepend-icon="mdi-check" elevation="0" dark x-small @click="saveGrade(item)">
								ذخیره
							</v-btn>
						</div>
					</div>
					<div class="d-flex flex-column justify-center" style="flex-grow: 2; border-left: 1px dashed grey;padding: 5px;">
						<div class="d-flex"><v-icon small color="grey" class="ml-2">mdi-calendar</v-icon><span class="grey--text">{{ item.date_Persian.date }}</span></div>
						<div class="d-flex"><span>{{ item.status}}</span></div>
						<div class="d-flex" v-if="item.errorsText"><v-icon x-small color="error">mdi-alert-circle-outline</v-icon><span class="error--text">خطاها: {{ item.errorsText }}</span></div>
					</div>
					<div class="px-2 d-flex flex-column justify-center">
						<a v-if="!item.url && !item.reportPdfFileName" href="#" style="text-decoration: none;font-size: 11px;" class="secondary--text link" @click="getStatus(item.id)">دریافت نتیجه</a>
						<a :href="item.url" target="_blank" style="text-decoration: none;font-size: 11px;" class="secondary--text link" v-if="item.url">لینک مشاهده نتیجه</a>
						<a v-if="item.reportPdfFileName" :href="`/Ice/DownloadPdf/${item.id}`" target="_blank" style="text-decoration: none;font-size: 11px;" class="secondary--text link">دریافت pdf</a>
					</div>
				</div>
			</div>
			<div class="py-2 mt-2 text-center" v-if="!isAdmin">
				<v-btn @click="add">
					<v-icon>mdi-plus</v-icon>
					ثبت درخواست اعتبارسنجی جدید (هزینه {{ String(icePrice).toPriceFormat() }} تومان)
				</v-btn>
			</div>

		</div>
		<v-dialog v-model="dialogWalletCreditCharge" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">شارژ کیف پول</span></div>
					<v-spacer />
					<v-btn @click="dialogWalletCreditCharge = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<WalletCreditCharge ref="walletCreditCharge" v-if="dialogWalletCreditCharge" @callbck="callbck_walletCreditCharge" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogIceManager" scrollable persistent max-width="800px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت اعتبارسنجی ها</span></div>
					<v-spacer />
					<v-btn @click="dialogIceManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<IceManager v-if="dialogIceManager" @callbck="callbck_iceManager" :isAdmin="false" :isSummery="false" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
		<confirm-dlg ref="confirm" />
	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import { get } from 'vuex-pathify'
	import toast from '@/util/toast'

	export default {
		name: 'IceManager',
		props: {
			userId: { type: Number, default: 0 },
			isAdmin: Boolean,
			isSummery: Boolean,
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			WalletCreditCharge: () => import('@/components/forms/WalletCreditCharge'),
			IceManager: () => import('@/components/IceManager'),
		},
		data() {
			return {
				saveGradeLoading: '',
				items: [],
				userCredit: 0,
				dialogWalletCreditCharge: false,
				dialogIceManager: false,
				editGradeMode: false,
				grades: [
					{ value: 'A', title: 'A' },
					{ value: 'B', title: 'B' },
					{ value: 'C', title: 'C' },
					{ value: 'D', title: 'D' },
					{ value: 'E', title: 'E' },
					{ value: 'F', title: 'F' },
				]
			}
		},
		computed: {
			...get('memberAppSettings', [
				'icePrice',
			]),
		},
		mounted() {
			this.loadData()
			if (!this.isAdmin && !this.isSummery)
				this.loadUserCredit()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('member/IceReport/ListByMemberId/' + this.userId, null)
					.then(
						response => {
							this.items = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			loadUserCredit() {
				api.get('member/User/loadUserCredit/', null)
					.then(response => {
						this.userCredit = response
					})
					.catch(err => {
					})
					.finally(x => {
					})
			},
			update(updatedVal) {
				if (!updatedVal)
					return
				let index = this.patterns.findIndex(x => x.id === updatedVal.id)
				if (index > -1) {
					this.patterns[index] = updatedVal
					this.$emit('itemsUpdated', this.patterns)
				}
			},
			async add() {
				if (this.userCredit < this.icePrice) {
					toast.error('اعتبار کیف پول شما جهت اعتبارسنجی کافی نمی باشد.')
					return
				}
				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از ثبت درخواست اعتبارسنجی مطمئن هستید؟ با تایید این فرم در  صورت موفقیت آمیز بودن عملیات، هزینه عملیات از کیف پول شما کسر خواهد شد.',
				)) {
					api.post('member/IceReport/Create/')
						.then(
							response => {
								toast.success('درخواست با موفقیت ثبت شد.')
								this.loadData()
								this.loadUserCredit()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
			async getStatus(id) {
				if (!id) { return }

				api.get('member/IceReport/GetStatus/' + id)
					.then(response => {
						this.loadData()
					})
					.catch(err => {
						toast.error(err.message)
					})
			},
			callbck_walletCreditCharge() {
				this.dialogWalletCreditCharge = false
			},
			addWalletCreditCharge() {
				this.dialogWalletCreditCharge = true
			},
			callbck_iceCharge() {
				this.dialogIceManager = false
			},
			showIceManager() {
				this.dialogIceManager = true
			},
			callbck_iceManager() {

			},
			saveGrade(item) {
				this.saveGradeLoading = item.id
				api.post('admin/IceReport/SetGrade/', { iceReportId: item.id, grade: item.result })
					.then(
						response => {
							toast.success('رتبه با موفقیت ثبت شد.')
							this.loadData()
							console.log('ssss')
							this.editGradeMode = false
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.saveGradeLoading = ''
					})
			}
		}
	}
</script>
<style scoped>
	.pattern-tags {
		list-style: none;
	}
	.pattern-tags li {
		display: inline;
		margin: 3px;
		color: blueviolet;
	}
	.link {
		text-decoration: none;
		font-size: 11px;
		padding: 3px;
		border-radius: 5px;
		border: 1px solid grey;
		margin-bottom: 3px;
		text-align: center;
	}
</style>
